// import { CallMade, Outbound, OutboundTwoTone } from "@mui/icons-material";
// import { Container, Grid, Typography, Box } from "@mui/material";
// import React from "react";
import { ActionIcon, Anchor, Box, Container, Divider, Flex, Footer, Grid, Space, Text, Title } from "@mantine/core";
import { IconExternalLink } from "@tabler/icons-react";
import { Logo } from "../../components/Logo";

const COMPANY_NAME = "(주) ACME";
const BUSINESS_NUMBER = "123-88-12312";
const CEO = "김도현";
const TEL = "02-1234-1234";
const EMAIL = "kimtj@me.com";
const ADDRESS = "서울 송파구 법원로11길 12 한양타워 8층-A";

export default function MainFooter() {
  return (
    <Footer pt={50} bg="#182137" withBorder={false}>
      <Container>
        <Grid>
          <Grid.Col sx={12} md={4} mb={40}>
            <Logo white sx={{ height: 40 }} />
            <Text color="dimmed" mt={10}>
              © {COMPANY_NAME} All rights reserved.
            </Text>
          </Grid.Col>

          <Grid.Col sx={12} md={4} mb={40}>
            <Title order={2} color="white" mb={10}>
              {COMPANY_NAME}
            </Title>
            <Text color="white" mb={5}>
              사업자등록번호: {BUSINESS_NUMBER} ・ 대표자: {CEO}
            </Text>
            <Text color="white" mb={5}>
              T. {TEL} ・ E. {EMAIL}
            </Text>

            <Text color="white" mb={5}>
              {ADDRESS}
            </Text>
          </Grid.Col>

          <Grid.Col sx={12} md={4} mb={40}>
            <Title order={2} color="white" mb={10}>
              고객센터 및 지원
            </Title>
            <LinkItem title="02-1234-1234 (평일 09:00 ~ 18:00)" url="tel:01012341234" internal />
            <Space h="xs" />
            <LinkItem title="서비스 이용약관" url="https://naver.com" />
            <LinkItem title="개인정보 처리방침" url="https://naver.com" />
          </Grid.Col>
        </Grid>
      </Container>
    </Footer>
    // <Box bgcolor="#182137">
    //   <Container maxWidth="xl" sx={{ bgcolor: "#182137", py: 8, mt: 0, mb: 0 }}>
    //     <Grid container spacing={5}>
    //       <Grid item xs={12} md={2}>
    //         <Typography variant="h5" color="white">
    //           <Logo sx={{ filter: "brightness(0) invert(1)", maxWidth: "200px", mt: 0.5 }} />
    //         </Typography>
    //       </Grid>

    //       <Grid item xs={12} md={4}>
    //         <Typography variant="h5" color="primary.main" sx={{ mb: 2 }}>
    //           (주) 한국축산데이터
    //         </Typography>

    //         <Typography variant="body1" color="white" gutterBottom>
    //           사업자등록번호: 872-88-00873 ・ 대표자: 경노겸
    //         </Typography>

    //         <Typography variant="body1" color="white" gutterBottom>
    //           T. 02-6956-1120 ・ E. aidkr@aidkr.com
    //         </Typography>

    //         <Typography variant="body1" color="white" gutterBottom>
    //           서울 송파구 법원로11길 12 한양타워 8층-A
    //         </Typography>

    //         <Typography variant="body1" color="white" gutterBottom>
    //           © 한국축산데이터 All rights reserved.
    //         </Typography>
    //       </Grid>

    //       <Grid item xs={12} md={3}>
    //         <Typography variant="h5" color="primary.main" sx={{ mb: 2 }}>
    //           고객센터
    //         </Typography>

    //         <ExternalLink title="02-6956-1120 (평일 09:00 ~ 18:00)" url="https://naver.com" />
    //         <ExternalLink title="@한국축산데이터 (카카오채널)" url="https://naver.com" />
    //         <ExternalLink title="1:1 문의" url="https://naver.com" />
    //       </Grid>

    //       <Grid item xs={12} md={3}>
    //         <Typography variant="h5" color="primary.main" sx={{ mb: 2 }}>
    //           바로가기
    //         </Typography>

    //         <ExternalLink title="서비스 이용약관" url="https://naver.com" />
    //         <ExternalLink title="개인정보 처리방침" url="https://naver.com" />
    //       </Grid>
    //     </Grid>
    //   </Container>
    // </Box>
  );
}

const LinkItem = ({ title, url, internal = false }) => {
  return (
    <Anchor href={url} target={internal ? "_self" : "_blank"}>
      <Flex mb={5} align="center" gap={5}>
        <Text color="white">{title}</Text>
        <IconExternalLink size={20} color="white" />
      </Flex>
    </Anchor>
  );
};
